package com.evoapps.evoshift.util

import androidx.compose.material3.CalendarLocale
import kotlinx.browser.window

actual fun pickerCalendarLocale(language: String): CalendarLocale =
    CalendarLocale(pickerLocaleTag(language, window.navigator.language))
